// import React, { useEffect, useRef, useState, useContext } from "react";
// import { Link, useHistory } from "react-router-dom";
// import Swal from "sweetalert2";
// import Button from "react-bootstrap/Button";
// import Modal from "react-bootstrap/Modal";
// import { LanguageContext } from "../Components/LanguageContext";
// import { useTheme } from "../../ThemeContext";
// import { BsPerson, BsPencilSquare, BsCheckCircleFill } from 'react-icons/bs';
// import { LuIndianRupee } from "react-icons/lu";
// import { apiRequest } from "../../apiService/allApi";
// import Rightcontainer from "../Components/Rightcontainer";

// // Keep your CSS imports
// import "../css/layout.css";
// import css from "../css/Profile.module.css";
// import "../css/kyc.css";
// import "../css/Loader.css";

// const Profile1 = ({ profile }) => {
//   // --- KEEPING ALL YOUR EXISTING LOGIC & STATE UNTOUCHED ---
//   const translations = {
//     hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
//     en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
//   };

//   const { language } = useContext(LanguageContext);
//   const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
//   const [show, setShow] = useState(false);
//   const [show1, setShow1] = useState(false);
//   const handleClose = () => setShow1(false);
//   const handleShow = () => setShow1(true);
//   const [referral, setCode] = useState("");
//   const [Id, setId] = useState(null);
//   const [msg, setMsg] = useState("");
//   const [portcss, setPortcss] = useState(css.active_tab);
//   const [portcss1, setPortcss1] = useState(css.inactive_tab);
//   const [holder_name, setHolder_name] = useState();
//   const [account_number, setAccount_number] = useState();
//   const [ifsc_code, setIfsc_code] = useState();
//   const [upi_id, setUpi_id] = useState();
//   const [isLoading, setIsloading] = useState(false);
//   const [showKyc, setShowKyc] = useState(false);
//   const [process1, setProcesss] = useState(false);

//   const udata = localStorage.getItem("udata");
//   const profileData = JSON.parse(udata);
//   const siteData = localStorage.getItem("sitSetting");
//   const SData = JSON.parse(siteData);

//   const handleCloseKyc = () => setShowKyc(false);
//   const handleShowKyc = () => setShowKyc(true);
//   const [inputOpen, setInputOpen] = useState(false);
//   const [Email, setEmail] = useState(null);
//   const toggleInput = () => setInputOpen(!inputOpen);
//   const history = useHistory();

//   // --- ALL YOUR FUNCTIONS (NOT MODIFIED) ---
//   const logout = async () => {
//     localStorage.clear();
//     let access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     await apiRequest(`me`, "GET", null, headers)
//       .then(() => { /* logic */ })
//       .catch((e) => {
//         if (e.response?.status === 401) {
//           localStorage.removeItem("token");
//           window.location.reload();
//           history.push("/login");
//         }
//       });
//   };

//   const UpdateEmail = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Email != null) {
//       try {
//         const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
//         if (respone.data.status === false) {
//           Swal.fire({ title: respone.data.msg, icon: "error" });
//         } else {
//           setEmail(respone.data); setInputOpen(false);
//           Swal.fire({ title: respone.data.msg, icon: "success" });
//         }
//       } catch (error) { }
//     } else {
//       Swal.fire({ title: "Please enter your Email", icon: "error" });
//     }
//   };

//   const [Name, setName] = useState(null);
//   const UpdateProfile = async () => {
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     if (Name != null) {
//       const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
//       if (respone.data.status === false) {
//         Swal.fire({ title: respone.data.msg, icon: "error" });
//       } else {
//         setName(respone.data);
//         Swal.fire({ title: respone.data.msg, icon: "success" });
//       }
//     }
//   };

//   const [total, setTotal] = useState();
//   const TotalGame = async () => {
//     let access_token = localStorage.getItem("token");
//     let userId = localStorage.getItem("userId");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     try {
//       const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
//       if (res.data) setTotal(res.data);
//     } catch (e) { }
//   };

//   const Result = async (file) => {
//     if (file) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const formData = new FormData();
//       formData.append("avatar", file);
//       await apiRequest(`users/me/avatar`, "POST", formData, headers);
//     }
//   };

//   const Kyc = () => setShowKyc(true);

//   const [AadharNum, setAadharNum] = useState("");
//   const [userAdharData, setUserAdharData] = useState("");
//   const handleAdharChnage = (e) => setAadharNum(e.target.value);

//   const AdharNumber = async (e) => {
//     setIsloading(true); e.preventDefault();
//     if (/^[0-9]{12}$/.test(AadharNum)) {
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const data = { aadharNumber: AadharNum };
//       try {
//         const res = await apiRequest("aadharcard-auto", "POST", data, headers);
//         setUserAdharData(res?.data);
//         setIsloading(false);
//         if (res.data.status === false) setMsg(res?.data?.msg);
//         else setMsg(res?.data?.data?.message);
//       } catch (error) { console.log(error); }
//     } else {
//       Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required" });
//       setIsloading(false);
//     }
//   };

//   const [AadharOtp, setAadharOtp] = useState("");
//   const [isLoading1, setIsloading1] = useState(false);
//   const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

//   const AdharOtpFunc = async (e) => { // Renamed slightly to avoid collision with state
//     setIsloading1(true);
//     const access_token = localStorage.getItem("token");
//     const headers = { Authorization: `Bearer ${access_token}` };
//     const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
//     try {
//       const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
//       setIsloading1(false);
//       if (res.data.status === false) setMsg(res.data?.msg);
//       else window.location.reload();
//     } catch (e) { console.log(e); }
//   };

//   let aadharProcess = useRef(false);
//   const [Names, setNames] = useState("");
//   const [DOB, setDob] = useState("");
//   const [frontLoaded, setFrontLoaded] = useState(null);
//   const [backLoaded, setBackLoaded] = useState(null);

//   const handleSubmitdata = async (e) => {
//     e.preventDefault();
//     if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
//       alert("All fields required"); return;
//     }
//     if (aadharProcess.current === false) {
//       setProcesss(true); aadharProcess.current = true;
//       const formData = new FormData();
//       formData.append("Name", Names); formData.append("DOB", DOB);
//       formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
//       formData.append("Number", AadharNum); formData.append("Email", Email);
//       const access_token = localStorage.getItem("token");
//       const headers = { Authorization: `Bearer ${access_token}` };
//       const res = await apiRequest(`aadharcard`, "POST", formData, headers);
//       if (res.data.status === false) {
//         Swal.fire({ title: res.data.msg, icon: "error" }).then(() => handleCloseKyc());
//       } else {
//         Swal.fire({ title: "KYC submitted", icon: "success" }).then(() => handleCloseKyc());
//         history.push("/Profile");
//       }
//       aadharProcess.current = false; setProcesss(false);
//     }
//   };

//   useEffect(() => { TotalGame(); }, []);

//   const [isValidEmail, setIsValidEmail] = useState(true);
//   const handleEmailChange = (e) => {
//     const newEmail = e.target.value;
//     setEmail(newEmail);
//     const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
//     setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
//   };

//   const theme = localStorage.getItem('theme');
//   const styles = {
//     backgroundColor: theme === 'light' ? '#f0f2f5' : '#0f0f1b',
//     color: theme === 'light' ? '#333' : '#fff',
//   };

//   // --- NEW UI RENDERING ---
//   return (
//     <>
//       <div className="leftContainer mt-4 mb_space" style={{ ...styles, minHeight: "100vh" }}>
//         <div className="profile_page_new pt-4 px-3">

//           {/* 1. Header Card (Premium Look) */}
//           <div className="premium_card mb-4">
//             <div className="card_accent"></div>
//             <div className="d-flex align-items-center p-3">
//               <div className="avatar_container position-relative">
//                 <label style={{ cursor: 'pointer' }}>
//                   <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
//                   <img
//                     src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar5.png"}
//                     alt="User"
//                     className="main_profile_img"
//                   />
//                   <div className="camera_badge"><BsPencilSquare size={12} /></div>
//                 </label>
//               </div>
//               <div className="ms-3 flex-grow-1">
//                 {portcss === css.active_tab ? (
//                   <div className="d-flex align-items-center">
//                     <h2 className="profile_name_text mb-0">{profile?.Name || "Player"}</h2>
//                     <BsPencilSquare
//                       className="ms-2 text-warning"
//                       onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
//                       style={{ cursor: 'pointer' }}
//                     />
//                   </div>
//                 ) : (
//                   <div className="d-flex">
//                     <input
//                       type="text"
//                       className="edit_name_input"
//                       value={Name}
//                       onChange={(e) => setName(e.target.value)}
//                     />
//                     <button className="btn_save_name ms-2" onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}>
//                       <BsCheckCircleFill />
//                     </button>
//                   </div>
//                 )}
//               </div>
//               <div className="kyc_badge_area">
//                 {profile?.verified === "verified" ? (
//                   <span className="badge_verified">VERIFIED</span>
//                 ) : (
//                   <span className="badge_pending" onClick={Kyc}>UNVERIFIED</span>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* 2. Stats Grid */}
//           <div className="stats_grid_premium mb-4">
//             <div className="stat_item blue_glow">
//               <img src="/images/crossswords.png" alt="" />
//               <div className="stat_text">
//                 <span className="stat_label">{translations[language].game}</span>
//                 <h3 className="stat_val">{String(total?.stringValue ?? total ?? "0")}</h3>
//               </div>
//             </div>
//             <div className="stat_item gold_glow">
//               <img src="/Coin without Glow.gif" alt="" />
//               <div className="stat_text">
//                 <span className="stat_label">{translations[language].Win}</span>
//                 <h3 className="stat_val">₹{String(profile?.wonAmount?.stringValue ?? "0")}</h3>
//               </div>
//             </div>
//             {/* <div className="stat_item green_glow">
//                 <img src="/images/refer1.png" alt="" />
//                 <div className="stat_text">
//                   <span className="stat_label">Referral</span>
//                   <h3 className="stat_val">₹{String(profile?.referral_earning?.stringValue ?? "0")}</h3>
//                 </div>
//              </div> */}
//             {/* <div className="stat_item purple_glow">
//                 <img src="/images/cash-withdrawal.png" alt="" />
//                 <div className="stat_text">
//                   <span className="stat_label">Withdrawal</span>
//                   <h3 className="stat_val">₹{String(profile?.totalWithdrawl?.stringValue ?? "0")}</h3>
//                 </div>
//              </div> */}
//           </div>

//           {/* 3. Account Details List */}
//           <div className="account_details_card p-3 mb-4">
//             <h4 className="section_title">General Details</h4>

//             <div className="detail_row d-flex justify-content-between align-items-center">
//               <div className="d-flex align-items-center">
//                 <div className="row_icon"><img src="/images/phone.png" width="20" /></div>
//                 <div className="row_content ms-3">
//                   <label>Phone Number</label>
//                   <p>{profile?.Phone}</p>
//                 </div>
//               </div>
//             </div>

//             <div className="detail_row d-flex justify-content-between align-items-center">
//               <div className="d-flex align-items-center">
//                 <div className="row_icon"><img src="/images/mail.png" width="20" /></div>
//                 <div className="row_content ms-3">
//                   <label>Email ID</label>
//                   <p>{profile?.Email || "Not Updated"}</p>
//                 </div>
//               </div>
//               <BsPencilSquare className="text-primary" onClick={toggleInput} style={{ cursor: 'pointer' }} />
//             </div>

//             {inputOpen && (
//               <div className="email_update_box mt-2">
//                 <input
//                   type="email"
//                   className="modern_input"
//                   placeholder="New Email Address"
//                   value={Email}
//                   onChange={handleEmailChange}
//                 />
//                 <button className="btn_update_email mt-2 w-100" onClick={UpdateEmail}>Update Email</button>
//               </div>
//             )}

//             {/* <div className="detail_row border-0 d-flex justify-content-between align-items-center" onClick={Kyc} style={{cursor:'pointer'}}>
//                 <div className="d-flex align-items-center">
//                    <div className="row_icon"><img src="/images/kyc.png" width="20"/></div>
//                    <div className="row_content ms-3 ml-3">
//                       <label>KYC Status</label>
//                       <p className={profile?.verified === "verified" ? "text-success" : "text-warning"}>
//                         {profile?.verified === "verified" ? "Verified User" : "Complete KYC Verification"}
//                       </p>
//                    </div>
//                 </div>
//                 <div className="arrow_right">{'>'}</div>
//              </div> */}
//            <div
//   className="detail_row border-0 d-flex justify-content-between align-items-center"
//   // Clickable only if NOT verified AND NOT pending
//   onClick={
//     profile?.verified === "verified" || profile?.verified === "pending"
//       ? null
//       : Kyc
//   }
//   style={{
//     cursor:
//       profile?.verified === "verified" || profile?.verified === "pending"
//         ? "default"
//         : "pointer",
//   }}
// >
//   <div className="d-flex align-items-center">
//     <div className="row_icon">
//       <img src="/images/kyc.png" width="20" alt="kyc" />
//     </div>
//     <div className="row_content ms-3 ml-3">
//       <label>KYC Status</label>
//       <p
//         className={
//           profile?.verified === "verified"
//             ? "text-success"
//             : profile?.verified === "pending"
//             ? "text-info" // Use info (blue) or primary for pending
//             : "text-warning"
//         }
//       >
//         {/* Dynamic Status Text */}
//         {profile?.verified === "verified"
//           ? "Verified"
//           : profile?.verified === "pending"
//           ? "Pending Verification"
//           : "Complete KYC Verification"}
//       </p>
//     </div>
//   </div>

//   <div className="arrow_right">
//     {/* Show arrow only if user is unverified (not verified and not pending) */}
//     {profile?.verified === "verified" || profile?.verified === "pending"
//       ? ""
//       : ">"}
//   </div>
// </div>
//           </div>

//           <div className="logout_container text-center mb-5">
//             <button className="premium_logout_btn" onClick={logout}>
//               <span>LOGOUT ACCOUNT</span>
//             </button>
//           </div>
//         </div>

//         {/* --- MODAL (Functionality Untouched, UI Cleaned) --- */}
//         <Modal show={showKyc} onHide={handleCloseKyc} centered className="dark_modal">
//           <Modal.Header closeButton className="border-0">
//             <Modal.Title style={{ color: "#000" }}>Verification Center</Modal.Title>
//           </Modal.Header>
//           <Modal.Body className="pt-0">
//             <ul className="nav nav-pills modern_tabs mb-3" id="kycTab" role="tablist">
//               {SData.onlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Online</button>
//                 </li>
//               )}
//               {SData.offlineKYC && (
//                 <li className="nav-item flex-fill">
//                   <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline"> Offline Kyc</button>
//                 </li>
//               )}
//             </ul>

//             <div className="tab-content mt-4">
//               {SData.onlineKYC && (
//                 <div className="tab-pane fade show active" id="online">
//                   <div className="form-group mb-3">
//                     <label className="small text-secondary">Aadhar Number</label>
//                     <input type="number" className="modern_input" value={AadharNum} onChange={handleAdharChnage} placeholder="12 Digit Aadhar" />
//                     <p className="text-danger small mt-1">{msg}</p>
//                   </div>
//                   {isLoading ? <div className="text-center"><img src='/images/LandingPage_img/loader1.gif' width="40" /></div> :
//                     userAdharData?.data?.status !== "SUCCESS" && <button className="btn_premium_modal w-100" onClick={AdharNumber}>Send OTP</button>
//                   }
//                   {userAdharData?.data?.status === "SUCCESS" && (
//                     <div className="mt-3">
//                       <input type="number" className="modern_input" value={AadharOtp} onChange={handleAdharOtpChnage} placeholder="Enter OTP" />
//                       <button className="btn_premium_modal w-100 mt-2" onClick={AdharOtpFunc}>Submit OTP</button>
//                     </div>
//                   )}
//                 </div>
//               )}
//               {SData.offlineKYC && (
//                 <div className="tab-pane fade" id="offline">
//                   <input type="text" className="modern_input mb-3" placeholder="Full Name" value={Names} onChange={(e) => setNames(e.target.value)} />
//                   <input type="text" className="modern_input mb-3" placeholder="Aadhar Number" value={AadharNum} onChange={handleAdharChnage} />
//                   <input type="date" className="modern_input mb-3" value={DOB} onChange={(e) => setDob(e.target.value)} />
//                   <div className="file_upload_area mb-3">
//                     <label>Front Photo</label>
//                     <input type="file" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <div className="file_upload_area mb-3">
//                     <label>Back Photo</label>
//                     <input type="file" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" />
//                   </div>
//                   <button className="btn_premium_modal w-100" onClick={handleSubmitdata}>Submit Verification</button>
//                 </div>
//               )}
//             </div>
//           </Modal.Body>
//         </Modal>
//       </div>

//       <div className="rightContainer">
//         <Rightcontainer />
//       </div>

//       <style dangerouslySetInnerHTML={{
//         __html: `
//         .premium_card { background: #1a1a2e; border-radius: 15px; position: relative; overflow: hidden; border: 1px solid #2a2a45; box-shadow: 0 10px 30px rgba(0,0,0,0.5); }
//         .card_accent { position: absolute; top:0; left:0; width: 100%; height: 4px; background: linear-gradient(90deg, #f39c12, #e67e22); }
//         .main_profile_img { width: 70px; height: 70px; border-radius: 50%; border: 3px solid #f39c12; object-fit: cover; }
//         .camera_badge { position: absolute; bottom: 0; right: 0; background: #f39c12; border-radius: 50%; padding: 4px; border: 2px solid #1a1a2e; }
//         .profile_name_text { font-size: 1.2rem; font-weight: 700; color: #fff; margin-left: 10px; }
//         .badge_verified { background: rgba(46, 204, 113, 0.2); color: #2ecc71; border: 1px solid #2ecc71; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; }
//         .badge_pending { background: rgba(231, 76, 60, 0.2); color: #e74c3c; border: 1px solid #e74c3c; padding: 4px 10px; border-radius: 20px; font-size: 10px; font-weight: 800; cursor:pointer; }
//         .stats_grid_premium { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; }
//         .stat_item { background: #1a1a2e; padding: 15px; border-radius: 12px; display: flex; align-items: center; border: 1px solid #2a2a45; }
//         .stat_item img { width: 35px; height: 35px; margin-right: 12px; }
//         .stat_label { font-size: 10px; color: #888; text-transform: uppercase; display: block; }
//         .stat_val { font-size: 1.1rem; font-weight: 800; margin: 0; color: #fff; }
//         .blue_glow { border-left: 4px solid #3498db; }
//         .gold_glow { border-left: 4px solid #f1c40f; }
//         .green_glow { border-left: 4px solid #2ecc71; }
//         .purple_glow { border-left: 4px solid #9b59b6; }
//         .account_details_card { background: #000; border-radius: 15px; border: 1px solid #2a2a45; }
//         .section_title { font-size: 0.9rem; font-weight: 700; color: #f39c12; text-transform: uppercase; margin-bottom: 15px; }
//         .detail_row { padding: 12px 0; border-bottom: 1px solid #2a2a45; }
//         .row_icon { width: 40px; height: 40px; background: #252545; border-radius: 10px; display: flex; align-items: center; justify-content: center; }
//         .row_content label { font-size: 10px; color: #888; margin:0; }
//         .row_content p { font-size: 14px; color: #fff; margin:0; font-weight: 600; }
//         .modern_input { background: #ffff; border: 1px solid #2a2a45; color: #000; padding: 10px; border-radius: 8px; width: 100%; outline: none; transition: 0.3s; }
//         .modern_input:focus { border-color: #f39c12; box-shadow: 0 0 10px rgba(243, 156, 18, 0.2); }
//         .premium_logout_btn { background: linear-gradient(90deg, #e74c3c, #c0392b); color: #fff; border: none; padding: 12px 40px; border-radius: 30px; font-weight: 800; letter-spacing: 1px; width: 80%; transition: 0.3s; }
//         .premium_logout_btn:hover { transform: translateY(-2px); box-shadow: 0 5px 15px rgba(231, 76, 60, 0.4); }
//         .modern_tabs .nav-link { background: #0f0f1b; color: #888; border: 1px solid #2a2a45; margin: 0 5px; font-size: 14px; font-weight: 600; }
//         .modern_tabs .nav-link.active { background: #f39c12 !important; color: #fff; border-color: #f39c12; }
//         .btn_premium_modal { background: #f39c12; color: #fff; border: none; padding: 10px; border-radius: 8px; font-weight: 700; }
//         .dark_modal .modal-content { background: #1a1a2e; color: #fff; border: 1px solid #2a2a45; border-radius: 20px; }
//         .file_upload_area { border: 2px dashed #2a2a45; padding: 10px; border-radius: 10px; text-align: center; }
//         .file_upload_area label { font-size: 12px; color: #f39c12; display: block; }
//       `}} />
//     </>
//   );
// };

// export default Profile1;

import React, { useEffect, useRef, useState, useContext } from "react";
import { Link, useHistory } from "react-router-dom";
import Swal from "sweetalert2";
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";
import { LanguageContext } from "../Components/LanguageContext";
import { useTheme } from "../../ThemeContext";
import { BsPerson, BsPencilSquare, BsCheckCircleFill } from 'react-icons/bs';
import { LuIndianRupee } from "react-icons/lu";
import { apiRequest } from "../../apiService/allApi";
import Rightcontainer from "../Components/Rightcontainer";

// Keep your CSS imports
import "../css/layout.css";
import css from "../css/Profile.module.css";
import "../css/kyc.css";
import "../css/Loader.css";

const Profile1 = ({ profile }) => {
  const translations = {
    hi: { wallet: 'वॉलेट', refer: 'किसी मित्र का रेफर कोड इस्तेमाल करे', win: 'पैसा जिता', game: 'गेम खेला', referEarn: 'रेफरल कमाई', referPerson: 'आमंत्रित किये दोस्त' },
    en: { wallet: 'My Wallet', refer: 'Use Refer Code', Win: 'Coin Won', game: 'Battle Played', referEarn: 'Referral Earning', referPerson: 'Referred Players' },
  };

  const { language } = useContext(LanguageContext);
  const baseUrl = process.env.REACT_APP_BACKEND_LOCAL_API;
  const [show, setShow] = useState(false);
  const [show1, setShow1] = useState(false);
  const handleClose = () => setShow1(false);
  const handleShow = () => setShow1(true);
  const [referral, setCode] = useState("");
  const [Id, setId] = useState(null);
  const [msg, setMsg] = useState("");
  const [portcss, setPortcss] = useState(css.active_tab);
  const [portcss1, setPortcss1] = useState(css.inactive_tab);
  const [holder_name, setHolder_name] = useState();
  const [account_number, setAccount_number] = useState();
  const [ifsc_code, setIfsc_code] = useState();
  const [upi_id, setUpi_id] = useState();
  const [isLoading, setIsloading] = useState(false);
  const [showKyc, setShowKyc] = useState(false);
  const [process1, setProcesss] = useState(false);

  const udata = localStorage.getItem("udata");
  const profileData = JSON.parse(udata);
  const siteData = localStorage.getItem("sitSetting");
  const SData = JSON.parse(siteData);

  const handleCloseKyc = () => setShowKyc(false);
  const handleShowKyc = () => setShowKyc(true);
  const [inputOpen, setInputOpen] = useState(false);
  const [Email, setEmail] = useState(null);
  const toggleInput = () => setInputOpen(!inputOpen);
  const history = useHistory();

  const logout = async () => {
    localStorage.clear();
    let access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    await apiRequest(`me`, "GET", null, headers)
      .then(() => { /* logic */ })
      .catch((e) => {
        if (e.response?.status === 401) {
          localStorage.removeItem("token");
          window.location.reload();
          history.push("/login");
        }
      });
  };

  const UpdateEmail = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Email != null) {
      try {
        const respone = await apiRequest(`user/profile/edit`, "PATCH", { Email }, headers);
        if (respone.data.status === false) {
          Swal.fire({ title: respone.data.msg, icon: "error", background: '#1a1a2e', color: '#fff' });
        } else {
          setEmail(respone.data); setInputOpen(false);
          Swal.fire({ title: respone.data.msg, icon: "success", background: '#1a1a2e', color: '#fff' });
        }
      } catch (error) { }
    } else {
      Swal.fire({ title: "Please enter your Email", icon: "error", background: '#1a1a2e', color: '#fff' });
    }
  };

  const [Name, setName] = useState(null);
  const UpdateProfile = async () => {
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    if (Name != null) {
      const respone = await apiRequest(`user/profile/edit`, "PATCH", { Name }, headers);
      if (respone.data.status === false) {
        Swal.fire({ title: respone.data.msg, icon: "error", background: '#1a1a2e', color: '#fff' });
      } else {
        setName(respone.data);
        Swal.fire({ title: respone.data.msg, icon: "success", background: '#1a1a2e', color: '#fff' });
      }
    }
  };

  const [total, setTotal] = useState();
  const TotalGame = async () => {
    let access_token = localStorage.getItem("token");
    let userId = localStorage.getItem("userId");
    const headers = { Authorization: `Bearer ${access_token}` };
    try {
      const res = await apiRequest(`total/user/all/${userId}`, "GET", null, headers);
      if (res.data) setTotal(res.data);
    } catch (e) { }
  };

  const Result = async (file) => {
    if (file) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const formData = new FormData();
      formData.append("avatar", file);
      await apiRequest(`users/me/avatar`, "POST", formData, headers);
    }
  };

  const Kyc = () => setShowKyc(true);

  const [AadharNum, setAadharNum] = useState("");
  const [userAdharData, setUserAdharData] = useState("");
  const handleAdharChnage = (e) => setAadharNum(e.target.value);

  const AdharNumber = async (e) => {
    setIsloading(true); e.preventDefault();
    if (/^[0-9]{12}$/.test(AadharNum)) {
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const data = { aadharNumber: AadharNum };
      try {
        const res = await apiRequest("aadharcard-auto", "POST", data, headers);
        setUserAdharData(res?.data);
        setIsloading(false);
        if (res.data.status === false) setMsg(res?.data?.msg);
        else setMsg(res?.data?.data?.message);
      } catch (error) { console.log(error); }
    } else {
      Swal.fire({ icon: "error", title: "Invalid Aadhar", text: "12-digit required", background: '#1a1a2e', color: '#fff' });
      setIsloading(false);
    }
  };

  const [AadharOtp, setAadharOtp] = useState("");
  const [isLoading1, setIsloading1] = useState(false);
  const handleAdharOtpChnage = (e) => setAadharOtp(e.target.value);

  const AdharOtpFunc = async (e) => { 
    setIsloading1(true);
    const access_token = localStorage.getItem("token");
    const headers = { Authorization: `Bearer ${access_token}` };
    const data = { aadharNumber: AadharNum, otp: AadharOtp, Email: Email, transaction_id: userAdharData.data?.ref_id };
    try {
      const res = await apiRequest(`aadharcard-auto-verify`, "POST", data, headers);
      setIsloading1(false);
      if (res.data.status === false) setMsg(res.data?.msg);
      else window.location.reload();
    } catch (e) { console.log(e); }
  };

  let aadharProcess = useRef(false);
  const [Names, setNames] = useState("");
  const [DOB, setDob] = useState("");
  const [frontLoaded, setFrontLoaded] = useState(null);
  const [backLoaded, setBackLoaded] = useState(null);

  const handleSubmitdata = async (e) => {
    e.preventDefault();
    if (!Names || !DOB || !frontLoaded || !backLoaded || !AadharNum) {
      alert("All fields required"); return;
    }
    if (aadharProcess.current === false) {
      setProcesss(true); aadharProcess.current = true;
      const formData = new FormData();
      formData.append("Name", Names); formData.append("DOB", DOB);
      formData.append("front", frontLoaded[0]); formData.append("back", backLoaded[0]);
      formData.append("Number", AadharNum); formData.append("Email", Email);
      const access_token = localStorage.getItem("token");
      const headers = { Authorization: `Bearer ${access_token}` };
      const res = await apiRequest(`aadharcard`, "POST", formData, headers);
      if (res.data.status === false) {
        Swal.fire({ title: res.data.msg, icon: "error", background: '#1a1a2e', color: '#fff' }).then(() => handleCloseKyc());
      } else {
        Swal.fire({ title: "KYC submitted", icon: "success", background: '#1a1a2e', color: '#fff' }).then(() => handleCloseKyc());
        history.push("/Profile");
      }
      aadharProcess.current = false; setProcesss(false);
    }
  };

  useEffect(() => { TotalGame(); }, []);

  const [isValidEmail, setIsValidEmail] = useState(true);
  const handleEmailChange = (e) => {
    const newEmail = e.target.value;
    setEmail(newEmail);
    const emailRegex = /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/;
    setIsValidEmail(emailRegex.test(newEmail) && newEmail.toLowerCase().endsWith(".com"));
  };

  return (
    <>
      <style>
        {`
          .premium-profile-container {
            background: linear-gradient(135deg, #0a0f1c 0%, #000000 100%);
            min-height: 100vh;
            color: #ffffff;
            font-family: 'Segoe UI', Tahoma, Geneva, Verdana, sans-serif;
            overflow-x: hidden;
            padding-bottom: 80px;
          }

          .slide-up {
            animation: slideUp 0.6s ease-out forwards;
          }

          .glass-card {
            background: rgba(20, 25, 40, 0.7);
            backdrop-filter: blur(10px);
            border-radius: 12px;
            border: 1px solid rgba(255, 255, 255, 0.08);
            box-shadow: 0 15px 35px rgba(0,0,0,0.5);
            transition: all 0.3s ease;
          }

          .glass-card:hover {
            transform: translateY(-3px);
          }

          /* Profile Header */
          .profile-header-card {
            position: relative;
            overflow: hidden;
            padding: 20px;
          }

          .card-accent-top {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 4px;
            background: linear-gradient(90deg, #f0c022, #d4a71c);
          }

          .profile-avatar-wrap {
            position: relative;
            display: inline-block;
          }

          .premium-avatar-img {
            width: 75px;
            height: 75px;
            border-radius: 50%;
            border: 3px solid #f0c022;
            object-fit: cover;
            box-shadow: 0 5px 15px rgba(240, 192, 34, 0.3);
          }

          .premium-camera-badge {
            position: absolute;
            bottom: 0;
            right: 0;
            background: #f0c022;
            color: #000;
            border-radius: 50%;
            padding: 6px;
            display: flex;
            align-items: center;
            justify-content: center;
            border: 2px solid #141928;
            transition: transform 0.2s;
          }

          .profile-avatar-wrap:hover .premium-camera-badge {
            transform: scale(1.1);
          }

          .premium-profile-name {
            font-size: 22px;
            font-weight: 800;
            color: #ffffff;
            letter-spacing: 0.5px;
          }

          /* Status Badges */
          .badge-verified {
            background: rgba(37, 211, 102, 0.15);
            color: #25D366;
            border: 1px solid rgba(37, 211, 102, 0.3);
            padding: 6px 14px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 1px;
            text-transform: uppercase;
          }

          .badge-pending {
            background: rgba(240, 192, 34, 0.15);
            color: #f0c022;
            border: 1px solid rgba(240, 192, 34, 0.3);
            padding: 6px 14px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 1px;
            text-transform: uppercase;
            cursor: pointer;
            transition: all 0.3s;
          }

          .badge-unverified {
            background: rgba(231, 76, 60, 0.15);
            color: #e74c3c;
            border: 1px solid rgba(231, 76, 60, 0.3);
            padding: 6px 14px;
            border-radius: 20px;
            font-size: 11px;
            font-weight: 800;
            letter-spacing: 1px;
            text-transform: uppercase;
            cursor: pointer;
            transition: all 0.3s;
          }

          .badge-pending:hover, .badge-unverified:hover {
            transform: translateY(-2px);
            box-shadow: 0 5px 10px rgba(0,0,0,0.3);
          }

          /* Stats Grid */
          .premium-stats-grid {
            display: grid;
            grid-template-columns: 1fr 1fr;
            gap: 15px;
          }

          .premium-stat-box {
            display: flex;
            align-items: center;
            padding: 20px 15px;
          }

          .premium-stat-icon {
            width: 40px;
            height: 40px;
            margin-right: 15px;
          }

          .stat-accent-blue { border-bottom: 3px solid #0088cc; }
          .stat-accent-gold { border-bottom: 3px solid #f0c022; }

          .stat-title {
            font-size: 11px;
            color: #8892b0;
            text-transform: uppercase;
            font-weight: 700;
            letter-spacing: 0.5px;
          }

          .stat-value {
            font-size: 24px;
            font-weight: 800;
            color: #ffffff;
            margin: 0;
            line-height: 1.2;
          }

          /* Detail Rows */
          .premium-detail-row {
            display: flex;
            justify-content: space-between;
            align-items: center;
            padding: 18px 20px;
            background: rgba(20, 25, 40, 0.5);
            border: 1px solid rgba(255, 255, 255, 0.05);
            border-radius: 10px;
            margin-bottom: 12px;
            transition: all 0.3s ease;
          }

          .premium-detail-row:hover {
            background: rgba(20, 25, 40, 0.8);
            border-color: rgba(255, 255, 255, 0.1);
          }

          .detail-icon-wrap {
            background: rgba(255, 255, 255, 0.05);
            width: 45px;
            height: 45px;
            border-radius: 10px;
            display: flex;
            align-items: center;
            justify-content: center;
          }

          .detail-content {
            margin-left: 15px;
            flex: 1;
          }

          .detail-label {
            color: #8892b0;
            font-size: 11px;
            text-transform: uppercase;
            font-weight: 700;
            margin-bottom: 2px;
            display: block;
          }

          .detail-text {
            color: #ffffff;
            font-size: 15px;
            font-weight: 700;
            margin: 0;
          }

          /* Inputs & Buttons */
          .premium-input {
            width: 100%;
            background: rgba(0,0,0,0.4);
            border: 1px solid rgba(255,255,255,0.1);
            color: #ffffff;
            padding: 14px;
            border-radius: 8px;
            outline: none;
            transition: all 0.3s;
          }

          .premium-input:focus {
            border-color: #f0c022;
            box-shadow: 0 0 10px rgba(240, 192, 34, 0.2);
          }

          .premium-btn-gold {
            background: #f0c022;
            color: #000000;
            border: none;
            padding: 14px;
            border-radius: 8px;
            font-weight: 800;
            text-transform: uppercase;
            letter-spacing: 1px;
            width: 100%;
            transition: all 0.3s ease;
          }

          .premium-btn-gold:hover {
            background: #d4a71c;
            transform: translateY(-2px);
          }

          .premium-logout-btn {
            background: rgba(231, 76, 60, 0.1);
            color: #e74c3c;
            border: 1px solid rgba(231, 76, 60, 0.3);
            padding: 16px;
            border-radius: 10px;
            font-weight: 800;
            letter-spacing: 1px;
            width: 100%;
            text-transform: uppercase;
            transition: all 0.3s;
          }

          .premium-logout-btn:hover {
            background: rgba(231, 76, 60, 0.2);
            border-color: #e74c3c;
            transform: translateY(-2px);
          }

          /* KYC Modal Overrides */
          .premium-modal .modal-content {
            background: #141928 !important;
            border: 1px solid rgba(255,255,255,0.1) !important;
            color: #ffffff;
            border-radius: 16px;
          }

          .premium-modal .modal-header {
            border-bottom: 1px solid rgba(255,255,255,0.05);
          }

          .premium-modal .modal-title {
            color: #ffffff !important;
            font-weight: 800;
          }

          .premium-modal .btn-close {
            filter: invert(1) grayscale(100%) brightness(200%);
          }

          .premium-tabs {
            background: rgba(0,0,0,0.3);
            padding: 5px;
            border-radius: 10px;
          }

          .premium-tabs .nav-link {
            color: #8892b0;
            font-weight: 600;
            border-radius: 8px;
            padding: 10px;
          }

          .premium-tabs .nav-link.active {
            background: #f0c022 !important;
            color: #000000 !important;
          }

          .premium-file-upload {
            border: 1px dashed rgba(255,255,255,0.2);
            padding: 15px;
            border-radius: 10px;
            text-align: center;
            background: rgba(0,0,0,0.2);
          }

          .premium-file-upload label {
            color: #f0c022;
            font-weight: 600;
            font-size: 13px;
            display: block;
            margin-bottom: 8px;
          }

          @keyframes slideUp {
            from { opacity: 0; transform: translateY(20px); }
            to { opacity: 1; transform: translateY(0); }
          }
        `}
      </style>

      <div className="premium-profile-container leftContainer mt-5 pt-4" style={{ display: 'flex', flexWrap: 'wrap' }}>
        <div style={{ flex: '1 1 100%', maxWidth: '650px', margin: '0 auto', padding: '0 20px' }}>

          {/* 1. Header Card */}
          <div className="glass-card profile-header-card slide-up mb-4" style={{ animationDelay: '0.1s' }}>
            <div className="card-accent-top"></div>
            <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
              
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="profile-avatar-wrap">
                  <label style={{ cursor: 'pointer', margin: 0 }}>
                    <input type="file" className="d-none" accept="image/*" onChange={(e) => Result(e.target.files[0])} />
                    <img
                      src={profileData?.avatar ? `${baseUrl}/${profileData.avatar}` : "./images/avatars/Avatar5.png"}
                      alt="User"
                      className="premium-avatar-img"
                    />
                    <div className="premium-camera-badge"><BsPencilSquare size={12} /></div>
                  </label>
                </div>
                
                <div style={{ marginLeft: '15px' }}>
                  {portcss === css.active_tab ? (
                    <div style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
                      <h2 className="premium-profile-name margin-0">{profile?.Name || "Player"}</h2>
                      <BsPencilSquare
                        style={{ color: '#8892b0', cursor: 'pointer', fontSize: '16px' }}
                        onClick={() => { setPortcss(css.inactive_tab); setPortcss1(css.active_tab); }}
                      />
                    </div>
                  ) : (
                    <div style={{ display: 'flex', gap: '10px' }}>
                      <input
                        type="text"
                        className="premium-input"
                        style={{ padding: '8px 12px' }}
                        value={Name}
                        onChange={(e) => setName(e.target.value)}
                      />
                      <button 
                        style={{ background: '#f0c022', color: '#000', border: 'none', borderRadius: '6px', padding: '0 15px' }} 
                        onClick={() => { setPortcss(css.active_tab); setPortcss1(css.inactive_tab); UpdateProfile(); }}
                      >
                        <BsCheckCircleFill />
                      </button>
                    </div>
                  )}
                </div>
              </div>

              <div>
                {profile?.verified === "verified" ? (
                  <span className="badge-verified">Verified</span>
                ) : profile?.verified === "pending" ? (
                  <span className="badge-pending">Pending</span>
                ) : (
                  <span className="badge-unverified" onClick={Kyc}>Unverified</span>
                )}
              </div>

            </div>
          </div>

          {/* 2. Stats Grid */}
          <div className="premium-stats-grid slide-up mb-4" style={{ animationDelay: '0.2s' }}>
            <div className="glass-card premium-stat-box stat-accent-blue">
              <img src="/images/crossswords.png" alt="Games" className="premium-stat-icon" />
              <div>
                <span className="stat-title">{translations[language].game}</span>
                <h3 className="stat-value">{String(total?.stringValue ?? total ?? "0")}</h3>
              </div>
            </div>
            
            <div className="glass-card premium-stat-box stat-accent-gold">
              <img src="/Coin without Glow.gif" alt="Won" className="premium-stat-icon" />
              <div>
                <span className="stat-title">{translations[language].Win}</span>
                <h3 className="stat-value">₹{String(profile?.wonAmount?.stringValue ?? "0")}</h3>
              </div>
            </div>
          </div>

          {/* 3. Account Details Section */}
          <div className="slide-up mb-5" style={{ animationDelay: '0.3s' }}>
            <h4 style={{ color: '#ffffff', fontSize: '16px', fontWeight: '800', marginBottom: '15px', textTransform: 'uppercase' }}>
              General Details
            </h4>

            {/* Phone Row */}
            <div className="premium-detail-row">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="detail-icon-wrap"><img src="/images/phone.png" width="20" alt="Phone" /></div>
                <div className="detail-content">
                  <span className="detail-label">Phone Number</span>
                  <p className="detail-text">{profile?.Phone}</p>
                </div>
              </div>
            </div>

            {/* Email Row */}
            <div className="premium-detail-row">
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="detail-icon-wrap"><img src="/images/mail.png" width="20" alt="Email" /></div>
                <div className="detail-content">
                  <span className="detail-label">Email Address</span>
                  <p className="detail-text">{profile?.Email || "Not Updated"}</p>
                </div>
              </div>
              <BsPencilSquare style={{ color: '#0088cc', fontSize: '20px', cursor: 'pointer' }} onClick={toggleInput} />
            </div>

            {inputOpen && (
              <div className="glass-card" style={{ padding: '15px', marginTop: '-5px', marginBottom: '12px' }}>
                <input
                  type="email"
                  className="premium-input mb-3"
                  placeholder="New Email Address"
                  value={Email}
                  onChange={handleEmailChange}
                />
                <button className="premium-btn-gold" onClick={UpdateEmail}>Update Email</button>
              </div>
            )}

            {/* KYC Status Row */}
            <div 
              className="premium-detail-row"
              onClick={profile?.verified === "verified" || profile?.verified === "pending" ? null : Kyc}
              style={{ cursor: profile?.verified === "verified" || profile?.verified === "pending" ? "default" : "pointer" }}
            >
              <div style={{ display: 'flex', alignItems: 'center' }}>
                <div className="detail-icon-wrap"><img src="/images/kyc.png" width="20" alt="KYC" /></div>
                <div className="detail-content">
                  <span className="detail-label">KYC Verification</span>
                  <p className="detail-text" style={{ 
                    color: profile?.verified === "verified" ? "#25D366" : profile?.verified === "pending" ? "#f0c022" : "#e74c3c" 
                  }}>
                    {profile?.verified === "verified" ? "Verification Completed" : profile?.verified === "pending" ? "Pending Verification" : "Complete KYC Now"}
                  </p>
                </div>
              </div>
              {profile?.verified !== "verified" && profile?.verified !== "pending" && (
                <div style={{ color: '#8892b0', fontSize: '20px', fontWeight: 'bold' }}>{'>'}</div>
              )}
            </div>
          </div>

          {/* 4. Logout Button */}
          <div className="slide-up text-center mb-5" style={{ animationDelay: '0.4s' }}>
            <button className="premium-logout-btn" onClick={logout}>
              Log Out Account
            </button>
          </div>

        </div>
      </div>

      {/* KYC Modal */}
      <Modal show={showKyc} onHide={handleCloseKyc} centered className="premium-modal">
        <Modal.Header closeButton>
          <Modal.Title>Verification Center</Modal.Title>
        </Modal.Header>
        <Modal.Body style={{ padding: '25px' }}>
          
          <ul className="nav nav-pills premium-tabs mb-4 flex-nowrap" id="kycTab" role="tablist">
            {SData.onlineKYC && (
              <li className="nav-item flex-fill text-center">
                <button className="nav-link active w-100" id="online-tab" data-bs-toggle="tab" data-bs-target="#online">Fast Online</button>
              </li>
            )}
            {SData.offlineKYC && (
              <li className="nav-item flex-fill text-center">
                <button className="nav-link w-100" id="offline-tab" data-bs-toggle="tab" data-bs-target="#offline">Manual Upload</button>
              </li>
            )}
          </ul>

          <div className="tab-content">
            {SData.onlineKYC && (
              <div className="tab-pane fade show active" id="online">
                <div className="mb-4">
                  <label style={{ color: '#8892b0', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>AADHAAR NUMBER</label>
                  <input 
                    type="number" 
                    className="premium-input" 
                    value={AadharNum} 
                    onChange={handleAdharChnage} 
                    placeholder="Enter 12-Digit Number" 
                  />
                  <p style={{ color: '#e74c3c', fontSize: '12px', marginTop: '8px', margin: 0 }}>{msg}</p>
                </div>
                
                {isLoading ? (
                  <div className="text-center"><img src='/images/LandingPage_img/loaderred.gif' width="40" alt="Loading" /></div>
                ) : (
                  userAdharData?.data?.status !== "SUCCESS" && (
                    <button className="premium-btn-gold" onClick={AdharNumber}>Request OTP</button>
                  )
                )}

                {userAdharData?.data?.status === "SUCCESS" && (
                  <div className="mt-4">
                    <label style={{ color: '#8892b0', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>VERIFICATION OTP</label>
                    <input 
                      type="number" 
                      className="premium-input mb-3" 
                      value={AadharOtp} 
                      onChange={handleAdharOtpChnage} 
                      placeholder="Enter OTP Code" 
                    />
                    <button className="premium-btn-gold" onClick={AdharOtpFunc}>
                      {isLoading1 ? "Verifying..." : "Confirm & Verify"}
                    </button>
                  </div>
                )}
              </div>
            )}

            {SData.offlineKYC && (
              <div className="tab-pane fade" id="offline">
                <input type="text" className="premium-input mb-3" placeholder="Full Legal Name" value={Names} onChange={(e) => setNames(e.target.value)} />
                <input type="number" className="premium-input mb-3" placeholder="Aadhaar Number" value={AadharNum} onChange={handleAdharChnage} />
                
                <label style={{ color: '#8892b0', fontSize: '12px', fontWeight: 'bold', marginBottom: '8px', display: 'block' }}>DATE OF BIRTH</label>
                <input type="date" className="premium-input mb-3" value={DOB} onChange={(e) => setDob(e.target.value)} />
                
                <div className="premium-file-upload mb-3">
                  <label>Document Front Image</label>
                  <input type="file" onChange={(e) => setFrontLoaded(e.target.files)} accept="image/*" style={{ color: '#8892b0', fontSize: '13px' }} />
                </div>
                
                <div className="premium-file-upload mb-4">
                  <label>Document Back Image</label>
                  <input type="file" onChange={(e) => setBackLoaded(e.target.files)} accept="image/*" style={{ color: '#8892b0', fontSize: '13px' }} />
                </div>
                
                <button className="premium-btn-gold" onClick={handleSubmitdata} disabled={process1}>
                  {process1 ? "Uploading..." : "Submit Documents"}
                </button>
              </div>
            )}
          </div>
        </Modal.Body>
      </Modal>

      <div className="rightContainer hidden-mobile mobile-hide">
        <Rightcontainer />
      </div>
    </>
  );
};

export default Profile1;
